import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CookiePolicy() {
  return (
    <div className="nuuma-container py-24 md:py-32">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-nuuma-primary hover:text-nuuma-secondary transition-colors mb-6 group"
        >
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          Powrót do strony głównej
        </Link>
        <h1 className="text-3xl md:text-4xl font-display font-bold text-nuuma-primary mb-8">
          Polityka Plików Cookie
        </h1>
        <p className="text-nuuma-grey700">
          Ostatnia aktualizacja: {new Date().toLocaleDateString("pl-PL")}
        </p>
        <div className="mt-8 space-y-6 text-nuuma-grey800">
          <p>
            Niniejsza strona wykorzystuje pliki cookie w celu zapewnienia prawidłowego działania oraz w celach analitycznych.
          </p>
          <h2>Czym są pliki cookie?</h2>
          <p>
            Pliki cookie to małe pliki tekstowe zapisywane na Twoim urządzeniu podczas korzystania z serwisu internetowego.
          </p>
        </div>
      </div>
    </div>
  );
}
